/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Partial_Underline_LabelInputs */



/**
* | output |
* | --- |
* | "Partial Underline" |
*
* @param {Style_Guide_Manager_Partial_Underline_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_partial_underline_label = /** @type {((inputs?: Style_Guide_Manager_Partial_Underline_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Partial_Underline_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soulignement partiel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teilweise Unterstreichung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottolineatura parziale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Частичное подчеркивание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subrayado parcial")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("部分下划线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("部分下線")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आंशिक अंडरलाइन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sublinhado parcial")
	return /** @type {LocalizedString} */ ("Partial Underline")
});